import { memo } from "react"

import { cn } from "@/shared/utils"

type HeroTitleProps = {
  lineOne: string
  lineTwoPrefix: string
  lineTwoHighlight: string
  description: string
}

const TITLE_STYLE = {
  fontSize: "clamp(1.75rem, 1rem + 4vw, 6rem)",
  lineHeight: 1.08,
  letterSpacing: "-0.022em",
} as const

const DESC_STYLE = {
  fontSize: "clamp(0.9375rem, 0.5vw + 0.8125rem, 1.125rem)",
  lineHeight: 1.55,
  maxWidth: "44ch",
} as const

export const HeroTitle = memo(function HeroTitle({
  lineOne,
  lineTwoPrefix,
  lineTwoHighlight,
  description,
}: HeroTitleProps) {
  return (
    <div className="flex flex-col items-center gap-5 text-center lg:items-start lg:gap-6 lg:text-left">
      <h1
        style={TITLE_STYLE}
        className={cn(
          "font-display font-semibold text-mesa-primary",
          "[font-feature-settings:'ss01','ss02','cv11']",
          "[text-wrap:balance]",
          "motion-safe:animate-float-in",
        )}
      >
        <span className="block">{lineOne}</span>
        <span className="block">
          {lineTwoPrefix}
          {lineTwoPrefix.length > 0 ? " " : ""}
          <span className="text-mesa-accent">{lineTwoHighlight}</span>
        </span>
      </h1>

      <p
        style={DESC_STYLE}
        className="font-normal text-mesa-text-muted [text-wrap:pretty] motion-safe:animate-float-in motion-safe:[animation-delay:120ms]"
      >
        {description}
      </p>
    </div>
  )
})
